module.exports = __webpack_public_path__ + "static/media/downArrow_operating.c8df1e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/downArrow_operating.png
// module id = 1745
// module chunks = 0 1